const HORIZONTAL = 'calc(env(safe-area-inset-right) + 18px)';
const HORIZONTAL_LEFT = 'calc(env(safe-area-inset-left) + 18px)';

export const LIGHTBOX_HEADER_PADDING = `calc(env(safe-area-inset-top) + 12px) ${HORIZONTAL} 12px ${HORIZONTAL_LEFT}`;

export const LIGHTBOX_BODY_PADDING = `0 ${HORIZONTAL} calc(env(safe-area-inset-bottom) + 24px) ${HORIZONTAL_LEFT}`;
